import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";

/**
 * PUBLISHES THE KEYBOARD'S HEIGHT AS A CSS VARIABLE (`--keyboard-height`).
 *
 * iOS does not resize the web view when the keyboard opens; it slides over it. So a button
 * pinned to the bottom of the screen ends up underneath the keyboard, which is exactly
 * where the "Continue" button of every sign-up form lives. Layouts read the variable and
 * lift themselves; on the web it stays 0 and nothing moves.
 *
 * `resize: 'none'` in capacitor.config.ts is the other half: it stops iOS ALSO shrinking
 * the view, which would apply the inset twice.
 */
export function bindKeyboardHeight(): () => void {
  if (!Capacitor.isNativePlatform()) return () => {};

  const set = (px: number) =>
    document.documentElement.style.setProperty("--keyboard-height", `${px}px`);

  const shows = Keyboard.addListener("keyboardWillShow", (info) => set(info.keyboardHeight));
  const hides = Keyboard.addListener("keyboardWillHide", () => set(0));

  return () => {
    void shows.then((h) => h.remove());
    void hides.then((h) => h.remove());
    set(0);
  };
}
